import { render, staticRenderFns } from "./deliverManage.vue?vue&type=template&id=154c95da&scoped=true&"
import script from "./deliverManage.vue?vue&type=script&lang=js&"
export * from "./deliverManage.vue?vue&type=script&lang=js&"
import style0 from "./deliverManage.vue?vue&type=style&index=0&id=154c95da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "154c95da",
  null
  
)

export default component.exports